import { render } from "./QuotationDetails.vue?vue&type=template&id=16de7ac2&scoped=true&ts=true"
import script from "./QuotationDetails.vue?vue&type=script&lang=ts"
export * from "./QuotationDetails.vue?vue&type=script&lang=ts"

import "./QuotationDetails.vue?vue&type=style&index=0&id=16de7ac2&scoped=true&lang=scss"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16de7ac2"]])

export default __exports__